import React, {useState, useEffect} from 'react';
import {CircularProgress, Grid} from '@mui/material';
import { consoleToLog, decodeAccessToken, getServiceName } from '../util/AppUtil';
import { useNavigate } from 'react-router';
import {useSnackbar} from 'notistack';
import {useIsMount} from '../components/useIsMount';
import { makeStyles } from '@mui/styles';
import { fetchAccessToken } from '../util/AppUtil';

const useStyles = makeStyles((theme) => ({
    mainbg: {
        background: theme.palette.primary.light,
        height:'100vh'
    }
}))

const DashboardPage = (props) => {
    const navigate = useNavigate();
    const isMount = useIsMount();
    const classes = useStyles();

    const [serviceNameValidated, setserviceNameValidated] = useState(true);

    useEffect(() => {
        document.title = props.isAppDomainTyno ? 'Tyno' : 'eProcessify';
        let serviceName = getServiceName(window.location.href);

           
                const fetchToken = async () => {
                    try {
                    const data = await fetchAccessToken(props.isAppDomainTyno ? 'tyno' : serviceName);
                    if(data) {
                        consoleToLog('Response authenticateApi', data);
                        const {access_token, redirect_url, invalid_service, scope} = data;
                        const user_scope = scope?.join();
                        if(access_token) {
                            if(redirect_url) {
                                window.open(`${redirect_url}\?scope=${user_scope}`, '_self');
                            } else if(!redirect_url && !invalid_service) {
                                navigate(`/not-registered?service=${serviceName}`);
                            } else if(!redirect_url && invalid_service) {
                                window.open(`${process.env.REACT_APP_INVOICE_DOMAIN_URL}\?scope=${user_scope}`, '_self');
                            }
                        } else {
                            navigate(`/login?service=${props.isAppDomainTyno ? 'tyno' : 'invoices'}`);
                        }

                    } 
                    } catch (error) {
                        consoleToLog("error fetchAccessToken", error);
                    }
                };
            
                fetchToken();
                
    }, []);

    return (
        <div className={classes.mainbg}>
            {serviceNameValidated ?
                <Grid container sx={{justifyContent: 'center'}}>
                    <CircularProgress size={30} style={{marginTop:'30px'}}/>
                </Grid>
                :
                <Grid container sx={{justifyContent: 'center', alignItems: 'center'}}
                    style={{backgroundColor: '#f7f7f7 !important', height:'100%'}}
                    className={classes.bgImage}>
                    <img src='/images/404-not-found.png' />
                </Grid>            
            }
        </div>
    );
}

export default DashboardPage;